module.exports = __webpack_public_path__ + "img/5.0b02133a.png";